/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react'
import { Card, Clock, DateFormat } from '@utilities/components'
import { FaClipboardList, FaRunning, FaSwimmer } from 'react-icons/fa'

//Redux
import { useDispatch, useSelector, shallowEqual } from 'react-redux'

//leaflet
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import markerIconPng from "leaflet/dist/images/marker-icon.png"
import { Icon } from 'leaflet'

//Lodash
import { isEqual } from "lodash"

//ICON
import { FaTimes, FaPowerOff, FaCogs, FaMapPin, FaWind, FaCloudRain, FaTemperatureLow, FaTint, FaLocationArrow, FaRegImages, FaChevronCircleLeft, FaChevronCircleRight, FaChevronLeft, FaChevronRight, FaLightbulb, FaChevronDown, FaChevronUp, FaUserAlt } from "react-icons/fa";

//Slice
import { getStation, getStationStatistic, clearData } from '@core/redux/reducers/station/StationSlice'
import { getStationActivities, clearData as activitiesClearData } from '@core/redux/reducers/station/ActivitiesSlice'
import moment from 'moment'

//Component
import { Modal } from '@utilities/components'
import WindCard from './components/WindCard'

import { Link } from 'react-router-dom'

var defaultLocation = [0, 0]
function Weathering() {
    const dispatch = useDispatch()

    const [locationStore, setLocationStore] = useState([])
    const [thisLocation, setThisLocation] = useState(null)
    const [storeStatictic, setStoreStatictic] = useState(null)
    const [dayHour, setDayHour] = useState((new Date()).getHours())
    const [storeData, SetStoreData] = useState(null)
    const [storeRawData, SetStoreRawData] = useState(null)
    const [showModalImg, setShowModalImg] = useState(false) //State Show Modal Upload Img
    const [showLocation, setShowLocation] = useState(false)
    const [initialImage, setInitialImage] = useState(null) //Image
    const Menu = useRef(null)
    const [isShow, setIsShow] = useState(false)
    const [waitingToReconnect, setWaitingToReconnect] = useState(null)
    const [storeActivites, setStoreActivites] = useState(null)
    
    // get state
    const { station, auth, activities } = useSelector((state) => ({ station: state.station, auth: state.auth, activities: state.activities }), shallowEqual)

    //  destructuring data
    const { result_list, result } = station
    const { result: activities_result } = activities
    const { user } = auth

    function selectLocation(item) {
        setThisLocation(item)
    }

    function nextLocation() {
        let index = locationStore.findIndex((e) => e.stationid === thisLocation.stationid) + 1

        if (index <= locationStore.length - 1) {
            setThisLocation({ ...locationStore[index] })
        } else {
            setThisLocation({ ...locationStore[0] })
        }
    }

    function backLocation() {
        let index = locationStore.findIndex((e) => e.stationid === thisLocation.stationid) - 1
        if (index >= 0) {
            setThisLocation({ ...locationStore[index] })
        } else {
            setThisLocation({ ...locationStore[locationStore.length - 1] })
        }
    }

    useEffect(() => {
        const statistic = window.localStorage.getItem(`weathering-statistic-data`)
        const activities = window.localStorage.getItem(`weathering-activities-data`)
        const thisLocation = window.localStorage.getItem(`weathering-this-data`)
        const dumplog = window.localStorage.getItem(`'weathering-dump-log`)
        
        if(statistic) {
            setStoreStatictic(JSON.parse(statistic))
        }

        if(activities) {
            setStoreActivites(JSON.parse(activities))
        }

        if(thisLocation) {
            setThisLocation(JSON.parse(thisLocation))
        }

        if(dumplog) {
            SetStoreRawData(JSON.parse(dumplog))
        }
    }, [])

    useEffect(() => {
        setDayHour((new Date()).getHours())
        dispatch(getStation())
    }, [dispatch])

    useEffect(() => {
        if (result) {
            window.localStorage.setItem('weathering-statistic-data', JSON.stringify(result))
            setStoreStatictic(result)
        }
    }, [result])

    useEffect(() => {
        if (activities_result) {
            window.localStorage.setItem('weathering-activities-data', JSON.stringify(activities_result))
            setStoreActivites(activities_result)
        }

        dispatch(activitiesClearData())

    }, [activities_result])

    useEffect(() => {
        if (result_list != null) {            
            setLocationStore(result_list)

            if (result_list.length > 0) { 

                window.localStorage.setItem('weathering-this-data', JSON.stringify(result_list[0]))
                setThisLocation(result_list[0])
                
                //dispath other data
                dispatch(getStationStatistic({ station_id: result_list[0].stationid }))
                dispatch(getStationActivities({ station_id: result_list[0].stationid }))
            }
        }

        dispatch(clearData())

    }, [result_list])

    useEffect(() => {
        setWaitingToReconnect(null)

        if(thisLocation) {            
            const stationData = new WebSocket(`wss://apis.coastaltourism.info/ws-station/`)

            stationData.onopen = () => {
                stationData.send(JSON.stringify({ senser_id: thisLocation.macaddress }))
            }

            stationData.onmessage = message => {
                let obj = JSON.parse(message.data)
                let mapData = {...obj}
                mapData.updateon = Date.now()

                let stationList = [...locationStore]
                let stationIndex = stationList.findIndex(x => x.macaddress === obj.weatherId)

                if(stationIndex > -1) {
                    var station = {...stationList[stationIndex]}
                    var stationlog = {...station.stationlog}

                    stationlog.templature = obj.temperature
                    stationlog.createon = mapData.updateon
                    station.stationlog = stationlog

                    stationList[stationIndex] = station
                }
                
                setLocationStore(stationList)
                SetStoreRawData(mapData)
                window.localStorage.setItem('weathering-dump-log', JSON.stringify(mapData))
            }

            return () => {
                SetStoreRawData(null)
                stationData.close()
            }
        }

    }, [thisLocation])

    useEffect(() => {
        if (thisLocation) {
            
            if (waitingToReconnect) {
                return;
            }

            const client = new WebSocket(`wss://apis.coastaltourism.info/websocket-api/station/${thisLocation.stationid}/log`)
            
            client.onopen = () => {
                client.send(JSON.stringify({ topic: 'weather', station: thisLocation.stationid }))
            };

            client.onclose = () => {
                if (waitingToReconnect) {
                    return;
                };

                setWaitingToReconnect(true)

                setTimeout(() => setWaitingToReconnect(null), 60000)
            }

            client.onmessage = message => {
                let obj = JSON.parse(message.data)
                setDayHour((new Date()).getHours())
                SetStoreData(obj)
                // window.localStorage.setItem('weathering-dump-log', JSON.stringify(obj))

                if(storeData) {
                    var mapData = {
                        windDir: obj.winddirection,
                        windSpeed: obj.windspeed,
                        temperature: obj.templature,
                        humidity: obj.humidity,
                        light: obj.lightintensity,
                        rainfall: obj.rainwater,
                        updateon: obj.updateon
                    }

                    SetStoreRawData(mapData)
                }

                client.close()
            }    
        }
    }, [waitingToReconnect, thisLocation])

    useEffect(() => {
        const interval = setInterval(() => {
          if(thisLocation) {
            // dispatch(getStationStatistic({ station_id: thisLocation.stationid }))
            dispatch(getStationActivities({ station_id: thisLocation.stationid }))
          }
        }, 30000);

        return () => clearInterval(interval)
      }, [thisLocation])

    //Handle Modal Image
    function handleShowModalImg(path) {
        setInitialImage(path)
        setShowModalImg(true)
    }

    function handleHideModalImg() {
        setShowModalImg(false)
    }

    //Handle Location
    function toggleShowLocation() {
        setShowLocation(!showLocation)
    }

    function handleToggleShow() {
        setIsShow(!isShow)
    }

    function trimTime(rawTime) {
        if (rawTime) {
            let timeArr = rawTime.split(":")

            return `${timeArr[0]}:00`
        } else {
            return 'N/A'
        }
    }

    const closeOpenMenus = (e) => {
        if (Menu.current && isShow && !Menu.current.contains(e.target)) {
            setIsShow(false)
        }
    }

    document.addEventListener('mousedown', closeOpenMenus)
    // console.log(storeData)
    return (
        <div className={`max-w-screen min-h-screen relative w-full overflow-x-hidden`}>
            <div className='clouds absolute'>
                <div className='clouds-2'></div>
                <div className='clouds-3'></div>
            </div>
            <div className='container mx-auto flex mt-5 px-2'>
                <div className='mx-auto flex justify-end w-[100%] px-2 lg:px-[100px]'>
                    {user ?
                        <div className='relative' ref={Menu}>
                            <div className="flex text-xs gap-x-2 text-white cursor-pointer p-[10px] rounded-md hover:shadow-md " onClick={handleToggleShow}>
                                <FaUserAlt className='fill-white' size={17} />
                                {user ? user.userfullname : ""}
                            </div>
                            <div className={`bg-white ml-3 py-2 rounded-md ${isShow ? 'block' : 'hidden'} absolute right-0 text-sm z-50`}>
                                <Link to={`/admin`}>
                                    <div className='hover:bg-gray-100 flex py-1 px-4 cursor-pointer' >
                                        <FaCogs size={17} />
                                        <span className='my-auto ml-1'>แก้ไข Station</span>
                                    </div>
                                </Link>
                                <Link to={`/logout`}>
                                    <div className='hover:bg-gray-100 flex py-1 px-4 text-red-500 cursor-pointer' >
                                        <FaPowerOff size={17} />
                                        <span className='my-auto ml-1'>ออกจากระบบ</span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        : <Link to={`/login`}>
                            <div className="flex text-xs gap-x-2 text-white cursor-pointer p-[10px] rounded-md hover:shadow-md ">
                                <FaUserAlt className='fill-white' size={17} /> Login
                            </div>
                        </Link>
                    }
                </div>
            </div>

            <div className="container mx-auto">
                <div className="px-2 lg:px-[100px] py-10 mb-10 flex">
                    <div className='w-full'>
                        <div className='block relative'>
                            <div className='text-white w-full text-center font-bold text-lg lg:text-2xl'>{thisLocation ? thisLocation.stationname : null}</div>
                            <div className='text-white w-full text-center font-bold text-3xl lg:text-5xl mt-5'>{storeRawData ? Math.round(storeRawData.temperature) : 0}°</div>
                            <div className='text-white w-full text-center text-sm mt-5'><DateFormat /></div>
                            <div className='text-white w-full text-center text-sm'><Clock /></div>
                            <div className='absolute flex lg:hidden left-[10px] top-0 h-[95%]'>
                                <FaChevronLeft size={45} className='fill-white my-auto opacity-70 hover:opacity-90 cursor-pointer z-10' onClick={backLocation} />
                            </div>
                            <div className='absolute flex lg:hidden right-[10px] top-0 h-[95%]'>
                                <FaChevronRight size={45} className='fill-white my-auto opacity-70 hover:opacity-90 cursor-pointer z-10' onClick={nextLocation} />
                            </div>
                        </div>
                        <div className='mt-5 text-white'>
                            <div className=' grid grid-cols-1 lg:grid-cols-2'>
                                <div className='col-span-1 px-1'>
                                    <Card width="100%" shadow="0" height="100%" background="rgba(255, 255, 255, .2)" radius="8px" className="py-3 px-3 relative">
                                        <div className="flex text-xs gap-x-2"><FaWind className='fill-white' size={17} /> WIND</div>
                                        <div className='mt-4'>
                                            <div className='flex'>
                                                <span className='text-4xl odometer'>{storeRawData ? Math.round(storeRawData.windSpeed) : 0}</span>
                                                <span className='mt-auto'>m/s</span>
                                            </div>
                                            <div>
                                                <span className='text-xs prompt-light'>last update {moment.utc(storeRawData ? storeRawData.updateon : null).local().startOf('seconds').fromNow()}</span>
                                            </div>
                                        </div>
                                        <WindCard
                                            speedKm={storeStatictic ? Math.round(storeStatictic.windspeed_1hr_km) : 0}
                                            speedMI={storeStatictic ? Math.round(storeStatictic.windspeed_1hr_mi) : 0}
                                            roleTate={storeRawData ? Math.round(storeRawData.windDir) : 0}
                                        />
                                    </Card>
                                </div>
                                <div className='col-span-1 grid grid-cols-2 mt-5 lg:mt-0'>
                                    <div className='col-span-1 px-1'>
                                        <Card width="100%" shadow="0" height="215px" background="rgba(255, 255, 255, .2)" radius="8px" className="py-3 px-3 relative">
                                            <div className="absolute top-3 left-3 flex text-xs gap-x-2"><FaLightbulb className='fill-white' size={17} /> Light</div>
                                            <div className='h-full w-full font-bold text-3xl lg:text-5xl flex'>
                                                <span className='my-auto w-full text-center flex justify-center gap-x-3'>{storeRawData ? Math.round(storeRawData.light) : 0} <span className='text-base mt-auto'>Lux</span></span>

                                            </div>
                                            <div className='absolute bottom-1 right-0 px-3 text-xs prompt-light'>
                                                last update {moment.utc(storeRawData ? storeRawData.updateon : null).local().startOf('seconds').fromNow()}
                                            </div>
                                        </Card>
                                    </div>
                                    <div className='col-span-1 px-1'>
                                        <Card width="100%" shadow="0" height="215px" background="rgba(255, 255, 255, .2)" radius="8px" className="py-3 px-3 relative">
                                            <div className="flex text-xs gap-x-2"><FaCloudRain className='fill-white' size={17} /> RAINFALL</div>
                                            <div className='absolute' style={{ right: '15px', top: '10px' }}>
                                                <div className="icon">
                                                    {
                                                        storeRawData ?
                                                            storeRawData.rainfall > 0 ?
                                                                <>
                                                                    <span className="cloud dark"></span>
                                                                    <span className="rain"></span>
                                                                </>
                                                                :
                                                                dayHour >= 7 && dayHour <= 18 ?
                                                                    <>
                                                                        <span className="sun"></span>
                                                                        <span className="cloud"></span>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <span className="moon"></span>
                                                                        <span className="cloud dark"></span>
                                                                    </>
                                                            : null
                                                    }
                                                </div>
                                            </div>
                                            <div className='mt-4'>
                                                <div className='flex'>
                                                    <span className='text-4xl odometer'>{storeStatictic ? Math.round(storeStatictic.rainwater_24hr) : 0}</span>
                                                    <span className='mt-auto'>mm</span>
                                                </div>
                                                <div>
                                                    <span className='text-xs md:text-sm'>In last 24h</span> <small style={{ fontSize: '7pt', fontWeight: '100' }}> Time : {storeStatictic ? trimTime(storeStatictic.last_time_update) : '-'}</small>
                                                </div>
                                            </div>
                                            <div className='flex justify-end' style={{ marginTop: '1rem', marginRight: '3rem' }}>
                                                <span style={{ fontSize: '30pt', fontWeight: 'bold' }}>{storeRawData ? Math.round(storeRawData.rainfall) : 0}<span style={{ fontSize: '12pt' }}>mm</span></span>
                                            </div>
                                            <div className='absolute bottom-1 right-0 px-3 text-xs prompt-light'>
                                                last update {moment.utc(storeRawData ? storeRawData.updateon : null).local().startOf('seconds').fromNow()}
                                            </div>
                                        </Card>
                                    </div>
                                    <div className='col-span-1 px-1 mt-5 lg:mt-1'>
                                        <Card width="100%" shadow="0" height="215px" background="rgba(255, 255, 255, .2)" radius="8px" className="py-3 px-3 relative">
                                            <div className="absolute top-3 left-3 flex text-xs gap-x-2"><FaTemperatureLow className='fill-white' size={17} /> FEELS LIKE</div>
                                            <div className='h-full w-full font-bold text-3xl lg:text-5xl flex'>
                                                <span className='my-auto w-full text-center'>{storeRawData ? Math.round(storeRawData.temperature) : 0}°</span>
                                            </div>
                                            <div className='absolute bottom-1 right-0 px-3 text-xs prompt-light'>
                                                last update {moment.utc(storeRawData ? storeRawData.updateon : null).local().startOf('seconds').fromNow()}
                                            </div>
                                        </Card>
                                    </div>
                                    <div className='col-span-1 px-1 mt-5 lg:mt-1'>
                                        <Card width="100%" shadow="0" height="215px" background="rgba(255, 255, 255, .2)" radius="8px" className="py-3 px-3 relative">
                                            <div className="absolute top-3 left-3 flex text-xs gap-x-2"><FaTint className='fill-white' size={17} /> HUMIDITY</div>
                                            <div className='h-full w-full font-bold text-3xl lg:text-5xl flex'>
                                                <span className='my-auto w-full text-center'>{storeRawData ? Math.round(storeRawData.humidity) : 0}%</span>
                                            </div>
                                            <div className='absolute bottom-1 right-0 px-3 text-xs prompt-light'>
                                                last update {moment.utc(storeRawData ? storeRawData.updateon : null).local().startOf('seconds').fromNow()}
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                            </div>

                            <div className='grid grid-cols-1 mt-5'>
                                <div className='col-span-1 px-1'>
                                    <Card width="100%" shadow="0.2" height="100%" background="rgba(255, 255, 255, .2)" radius="8px" className="py-3 px-3">
                                        <div className="flex text-xs gap-x-2"><FaClipboardList className='fill-white' size={17} /> ACTIVITY</div>
                                        <div className='mt-3 whitespace-nowrap overflow-x-auto overflow-y-hidden w-full'>
                                            {
                                                storeActivites != null ?
                                                    storeActivites.sport.length > 0 ? 
                                                    storeActivites.sport.map((item, index) => {
                                                        return (
                                                            <div key={index} className='p-4 inline-block'>
                                                                {/* <FaRunning className='fill-white mx-auto' size={80} /> */}
                                                                <img src={item.sporticon} className='h-20 rounded-md' />
                                                                <div className='mx-auto'>
                                                                    {item.sportname}
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    : null
                                                : null
                                            }                                           
                                        </div>
                                    </Card>
                                </div>
                            </div>

                            <div className='grid grid-cols-1 mt-5'>
                                <div className='col-span-1 px-1'>
                                    <Card width="100%" shadow="0" height="100%" background="rgba(255, 255, 255, .2)" radius="8px" className="py-3 px-3">
                                        <div className="flex text-xs gap-x-2"><FaRegImages className='fill-white' size={17} /> REAL PICTURE</div>
                                        <div className='mt-2'>
                                            {
                                                storeData && storeData.station_image && storeData.station_image.length > 0 ?
                                                    <div className='whitespace-nowrap overflow-x-auto overflow-y-hidden w-full'>
                                                        {
                                                            storeData.station_image.slice(0).reverse().map((item, index) => (
                                                                <div className='inline-block px-1 cursor-pointer' key={'image-' + Math.random()} onClick={() => handleShowModalImg(item.image_path)}>
                                                                    <img src={item.image_path} className='h-56 rounded-md' />
                                                                </div>
                                                            ))
                                                        }

                                                    </div>
                                                    :
                                                    <div className='h-56 flex justify-center'>
                                                        <span className='my-auto'>NO IMAGE AVAILABLE</span>
                                                    </div>
                                            }
                                        </div>
                                    </Card>
                                </div>
                            </div>

                            <div className='grid grid-cols-1 mt-5'>
                                <div className='col-span-1 px-1'>
                                    <Card width="100%" shadow="0" height="100%" background="rgba(255, 255, 255, .2)" radius="8px" className="py-3 px-3">
                                        <div className="flex justify-between">
                                            <div className="flex gap-x-2 text-xs"><FaLocationArrow className='fill-white' size={17} /> STATION LOCATION</div>
                                            {
                                                showLocation ?
                                                    <FaChevronUp className='fill-white my-auto cursor-pointer hover:fill-slate-100' size={20} onClick={toggleShowLocation} />
                                                    :
                                                    <FaChevronDown className='fill-white my-auto cursor-pointer hover:fill-slate-100' size={20} onClick={toggleShowLocation} />
                                            }

                                        </div>
                                        {
                                            showLocation ?
                                                <div className='mt-3'>
                                                    <MapContainer center={thisLocation ? [thisLocation.stationlat, thisLocation.stationlong] : [7.198, 100.596]} zoom={15} scrollWheelZoom={true}>
                                                        <TileLayer
                                                            attribution='&copy; Weathering'
                                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                        />
                                                        <ChangeView center={thisLocation ? [thisLocation.stationlat, thisLocation.stationlong] : [7.198, 100.596]} zoom={15} />
                                                        <Marker position={thisLocation ? [thisLocation.stationlat, thisLocation.stationlong] : [7.198, 100.596]} icon={new Icon({ iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41] })} />
                                                    </MapContainer>
                                                </div> : null
                                        }
                                    </Card>
                                </div>
                            </div>

                            <div className='hidden lg:block mt-4 px-1 py-1 relative'>
                                <div className='absolute flex left-[-30px] h-[95%]'>
                                    <FaChevronCircleLeft size={45} className='my-auto opacity-70 hover:opacity-90 cursor-pointer z-10' onClick={backLocation} />
                                </div>
                                <div className='absolute flex right-[-30px] h-[95%]'>
                                    <FaChevronCircleRight size={45} className='my-auto opacity-70 hover:opacity-90 cursor-pointer z-10' onClick={nextLocation} />
                                </div>
                                <div className='whitespace-nowrap overflow-x-auto overflow-y-hidden w-full'>
                                    {/* List Location */}
                                    {
                                        locationStore && locationStore.length > 0 ?
                                            locationStore.map((item, index) => {
                                                return (
                                                    <div className='h-[200px] w-[200px] mr-2 inline-block' key={"location-" + index}>
                                                        <Card width="100%" shadow="0" height="100%" background={`rgba(255, 255, 255, ${isEqual(item, thisLocation) ? '.4' : '.2'})`} radius="8px" className={`py-3 px-3 cursor-pointer ${isEqual(item, thisLocation) ? '' : 'hover:opacity-90'}`} onClick={() => selectLocation(item)}>
                                                            <div className="absolute top-3 left-3 flex text-xs gap-x-2"><FaMapPin className='fill-white' size={17} /> {item.stationname}</div>
                                                            <div className='h-full w-full font-bold text-3xl lg:text-5xl flex'>
                                                                <span className='my-auto w-full text-center'>{item.stationlog && item.stationlog.templature ? Math.round(item.stationlog.templature) : 0}°</span>
                                                            </div>
                                                            <div className='absolute bottom-1 right-0 px-3 text-xs prompt-light'>
                                                                last update {moment.utc(item.stationlog && item.stationlog.createon ? item.stationlog.createon : null).local().startOf('seconds').fromNow()}
                                                            </div>

                                                        </Card>
                                                    </div>
                                                )
                                            })
                                            : null
                                    }
                                    {/* End List Location */}
                                </div>
                            </div>

                            <ModalImage isOpen={showModalImg} onHide={handleHideModalImg} allowBlackdrop={true} image={initialImage} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function ChangeView({ center, zoom }) {
    const map = useMap()
    if (!isEqual(defaultLocation, center)) {
        defaultLocation = center
        map.setView(center, zoom)
    }
    return null
}

function ModalImage({ isOpen, allowBlackdrop, onHide, image }) {
    return (
        <>
            <Modal isOpen={isOpen} allowBlackdrop={allowBlackdrop} onHide={onHide} sizing={'80%'}>
                <span className='w-full relative'>
                    <span className='absolute right-1 top-1'>
                        <FaTimes size={20} className='cursor-pointer fill-white opacity-70 hover:opacity-100' onClick={onHide} />
                    </span>
                    <img src={image} className="w-full rounded-lg shadow-md" />
                </span>
            </Modal>
        </>
    )
}

export default Weathering